import React, { useState, useEffect } from "react";
import "./DashboardLightArray.css";
import DashboardLight from "@components/VehicleDashboard/dashboardLight/DashboardLight.js";

import alertOutlineImage from "../../../images/dashboardLightsLogos/alert-outline.svg";
import gnssOperativeOutlineImage from "../../../images/dashboardLightsLogos/gnss-operative.svg";
import gnssInoperableOutlineImage from "../../../images/dashboardLightsLogos/gnss-inoperable.svg";
import gnssDegradedOutlineImage from "../../../images/dashboardLightsLogos/gnss-degraded.svg";
import lidarOperativeOutlineImage from "../../../images/dashboardLightsLogos/lidar-operative.svg";
import lidarInoperableOutlineImage from "../../../images/dashboardLightsLogos/lidar-inoperable.svg";
import lidarDegradedOutlineImage from "../../../images/dashboardLightsLogos/lidar-degraded.svg";
import lightOutlineImage from "../../../images/dashboardLightsLogos/car-light-dimmed.svg";
import toolOutlineImage from "../../../images/dashboardLightsLogos/tool.svg";
import toolrightOutlineImage from "../../../images/dashboardLightsLogos/tool-right.svg";
import toolleftOutlineImage from "../../../images/dashboardLightsLogos/tool-left.svg";
import tankInOutlineImage from "../../../images/dashboardLightsLogos/tank-in.svg";
import tankOutOutlineImage from "../../../images/dashboardLightsLogos/tank-out.svg";
import keyOutOutlineImage from "../../../images/dashboardLightsLogos/key.svg";
import engineOutOutlineImage from "../../../images/dashboardLightsLogos/engine.svg";
import emergencyStopOutlineImage from "../../../images/dashboardLightsLogos/emergency-stop.svg";
import toolFloatingOutlineImage from "../../../images/dashboardLightsLogos/tool-floating.svg";
import placeholderOutlineImage from "../../../images/dashboardLightsLogos/placeholder.svg";
import swapNormalOutlineImage from "../../../images/dashboardLightsLogos/swap-normal.svg";
import swapReverseOutlineImage from "../../../images/dashboardLightsLogos/swap-reverse.svg";
import electricAuxClosedOutlineImage from "../../../images/dashboardLightsLogos/electric-switch-closed.svg";
import electricAuxOpenOutlineImage from "../../../images/dashboardLightsLogos/electric-switch.svg";

const getImageSource = (isOn, status, imgSrc) => {
  if (isOn) {
    switch (status) {
      case "left":
        return toolleftOutlineImage;
      case "right":
        return toolrightOutlineImage;
      case "in":
        return tankInOutlineImage;
      case "operative":
        return (imgSrc === gnssInoperableOutlineImage ? gnssOperativeOutlineImage : lidarOperativeOutlineImage);
      case "degraded":
        return (imgSrc === gnssInoperableOutlineImage ? gnssDegradedOutlineImage : lidarDegradedOutlineImage);
      default:
        return imgSrc;
    }
  }
  return imgSrc;
};

export default function DashboardLightArray({ data, devices }) {

  const gnssStatus = devices.gnss && devices.gnss.status;
  const radarStatus = devices.radar && devices.radar.status;
    
  const lights = [
    { isOn: data.emergencyStopButton, status: "emergency", stateName: "Arret urgence", imgSrc: emergencyStopOutlineImage },
    { isOn: 1, status: radarStatus, stateName: "LiDAR", imgSrc: lidarDegradedOutlineImage },
    { isOn: 1, status: gnssStatus, stateName: "GPS", imgSrc: gnssInoperableOutlineImage },
    { isOn: data.danger, status: "emergency", stateName: "Danger", imgSrc: alertOutlineImage },
    { isOn: data.lights, status: "regular", stateName: "Phares", imgSrc: lightOutlineImage },
    { isOn: 1, status: data.enlargment ? "out" : "in", stateName: "Position chenilles", imgSrc: tankOutOutlineImage },
    { isOn: data.toolFloating, status: "regular", stateName: "Outil flottant", imgSrc: toolFloatingOutlineImage },
    { isOn: data.tool, status: data.toolDirection ? "right" : "left", stateName: "Outil", imgSrc: toolOutlineImage },
    { isOn: data.engine, status: "regular", stateName: "Moteur", imgSrc: engineOutOutlineImage }, 
    { isOn: data.ignition, status: "regular", stateName: "Ignition", imgSrc: keyOutOutlineImage },
    { isOn: false, status: "regular", stateName: false ? "Inversé" : "Normal", imgSrc: false ? swapReverseOutlineImage : swapNormalOutlineImage },
    { isOn: data.electricAux, status: "regular", stateName: "Electric aux", imgSrc: data.electricAux ? electricAuxClosedOutlineImage : electricAuxOpenOutlineImage },
  ];

  const numColumns = Math.ceil(Math.sqrt(lights.length));
  const numRows = Math.ceil(lights.length / numColumns);
  const containerHeight = 48 - (numRows - 1);
  const rowHeight = containerHeight / numRows;

  const gridStyle = {
    display: "grid",
    gridTemplateColumns: `repeat(${numColumns}, 1fr)`,
    gridAutoRows: `${rowHeight}vh`,
    gap: "1vh",
  };

  return (
    <>
      <div style={gridStyle}>
        {lights.map((light, index) => (
          <DashboardLight key={index} {...light} imgSrc={getImageSource(light.isOn, light.status, light.imgSrc)} />
        ))}
      </div>
    </>
  );
}
